import {Tooltip} from "@blueprintjs/core";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const DragCellRenderer = ({
  isCompleted,
  isAllowResequence,
  content
}: {
  isCompleted: boolean;
  isAllowResequence: boolean;
  content: string;
}) => {
  return (
    !isCompleted && (
      <Tooltip
        popoverClassName="white-popover"
        disabled={isAllowResequence}
        content={content}
        placement="right"
        interactionKind="hover"
        enforceFocus={false}
        hoverCloseDelay={100}
      >
        <FontAwesomeIcon
          data-testid="drag-row-icon"
          size="lg"
          icon={solid("grip-dots-vertical")}
          color={isAllowResequence ? "#9CA3AF" : "#D1D5DB"}
          style={{cursor: "pointer"}}
        />
      </Tooltip>
    )
  );
};

export default DragCellRenderer;
